import $ from 'jquery';
import {Cookie, Popup} from '../utilities';
import onDocumentReady from "../utilities/onDocumentReady";

onDocumentReady(()=> {
    const refId = Cookie.get('REF');
    if (!refId) {
        return;
    }
    const refIsPreviewed = Cookie.get('REF_FIRST_NOTIFICATION_IS_PREVIEWED')

    if (refIsPreviewed !== 1) {
        const refRegisterType = Cookie.get('REF_REGISTER_TYPE');
        if (refRegisterType !== 'partner'){
            Cookie.set('REF_FIRST_NOTIFICATION_IS_PREVIEWED', 1,'',1);
            //$(`.ui-modal[data-name="ref-first-notification"]`).trigger('show');
        }
    }
})
